const buttonCls = "_uw7b1kp7be3";
const tooltipCls = "_uw7t5eqjla";
const audioButtonSpeechSynthesisWrapperCls = "_uw7av81ch1";
const audioButtonSpeechSynthesisCls = "_uw7a1u9fvpc";
const crossCls = "_uw7c1pbxect";

export { audioButtonSpeechSynthesisCls, audioButtonSpeechSynthesisWrapperCls, buttonCls, crossCls, tooltipCls };
import "./atom.audio-button.style.linaria.module.css";
//# sourceMappingURL=atom.audio-button.style.js.map
